module.exports = "- February 2010\n  - Facebook releases XHP\n  - extension to PHP\n\n- Prevent XSS\n  - Augment PHP syntax understand XML\n\n=> No more string escaping\n\n=> Custom tags (reuse, compose)\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_4.md
// module id = 1485
// module chunks = 0